'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToggleButton = require('./ToggleButton');

var _ToggleButton2 = _interopRequireDefault(_ToggleButton);

require('./ToggleInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var ToggleInput = function ToggleInput(_ref) {
    var value = _ref.value,
        label = _ref.label,
        active = _ref.active,
        onChange = _ref.onChange;
    return _react2.default.createElement(
        'label',
        { className: 'ToggleInput' },
        _react2.default.createElement('input', { type: 'checkbox', className: 'checkbox', value: value, checked: active, onChange: onChange }),
        _react2.default.createElement(_ToggleButton2.default, { active: active }),
        _react2.default.createElement(
            'span',
            { className: 'text' },
            label
        )
    );
};

// Styles


ToggleInput.propTypes = {
    onChange: _propTypes2.default.func,
    active: _propTypes2.default.bool,
    value: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.string.isRequired
};

exports.default = ToggleInput;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/fields/ToggleInput.js
// module id = 1778
// module chunks = 0